import AnimatedContent from './AnimatedContent';

const CtaSection = () => {
  return (
    <section id="cta" className="cta-section">
      <div className="section-container">
        <AnimatedContent
          distance={150}
          direction="vertical"
          reverse={false}
          duration={1.2}
          ease="bounce.out"
          initialOpacity={0.2}
          animateOpacity
          scale={1.1}
          threshold={0.2}
          delay={0.3}
        >
          <h2 className="section-heading">Let's Work Together</h2>
        </AnimatedContent>
        <p className="about-text">
          I'm always interested in new opportunities and exciting projects. 
          Whether you have a question or just want to say hi, feel free to reach out!
        </p>
        <div className="hero-cta">
          <button 
            className="primary-btn" 
            onClick={() => {
              const projectsSection = document.getElementById('projects');
              if (projectsSection) {
                projectsSection.scrollIntoView({
                  behavior: 'smooth',
                  block: 'start'
                });
              }
            }}
          >
            View Projects
          </button>
          <button className="secondary-btn">Get in Touch</button>
        </div>
      </div>
    </section>
  );
};

export default CtaSection;